export default "__VITE_ASSET__DBlcCcjw__"